import { promisifyDialog } from '@shared/utils/dialog'
import ActionsSheet from './ActionsSheet.vue'

export const openActionsSheet = (props: PromisifyDialogProps<typeof ActionsSheet>) => {
  return promisifyDialog(ActionsSheet, props)
}